<template>
  <!-- 非网关节点 -->
  <div
    v-if="[NODE.START, NODE.APPROVE, NODE.COPY].includes(nodeConfig.type)"
    class="node-wrap"
  >
    <div
      class="node-wrap-box"
      :class="{ 'start-node': nodeConfig.type === NODE.START }"
    >
      <div class="title" :style="{ background: nodeBgColor }">
        <!-- 开始节点 -->
        <span v-if="nodeConfig.type === NODE.START">{{ nodeConfig.name }}</span>
        <!-- 任务、办理、抄送节点 -->
        <template v-else>
          <input
            v-if="isNodeNameEdit"
            ref="nodeNameRef"
            v-model.trim="nodeConfig.name"
            type="text"
            class="editable-title-input"
            :maxlength="16"
            :placeholder="nodeDefaultName"
            @blur="onNameInputBlur()"
            @focus="focusInput"
          />
          <template v-else>
            <span class="editable-title">
              <span @click="onNameInputClick()">{{ nodeConfig.name }}</span>
            </span>
            <icon-close class="close" :size="14" @click="onNodeRemove" />
          </template>
        </template>
      </div>
      <div class="content" @click="onNodeCardClick(undefined)">
        <!-- 发起人节点 -->
        <!-- <a-tooltip
          v-if="nodeConfig.type === NODE.START"
          :content="showNodeContent"
          mini
          content-class="node-content-tooltip"
        >
        </a-tooltip> -->
        <span v-if="nodeConfig.type === NODE.START" class="text"
          >{{ nodeDefaultName }}{{ showNodeContent }}</span
        >
        <!-- 审核人、抄送人、办理人节点 -->
        <template
          v-else-if="[NODE.APPROVE, NODE.COPY].includes(nodeConfig.type)"
        >
          <span v-if="!showNodeContent" class="placeholder"
            >请选择{{ nodeDefaultName }}</span
          >
          <a-tooltip
            v-else
            mini
            :content="showNodeContent"
            content-class="node-content-tooltip"
          >
            <span class="text"
              >{{ nodeDefaultName }}：{{ showNodeContent }}
            </span>
          </a-tooltip>
        </template>
        <div v-if="nodeConfig.type !== NODE.START" style="color: #a1a5ad"
          ><icon-right
        /></div>
      </div>
    </div>
    <AddNode v-model:childNodeP="nodeConfig.childNode" />
  </div>

  <!-- 网关节点 -->
  <div v-if="nodeConfig.type === NODE.EXCLUSIVE_GATEWANY" class="branch-wrap">
    <div class="branch-box-wrap">
      <div class="branch-box">
        <button class="add-branch" @click="onConditionAdd()"
          ><icon-plus />添加条件</button
        >
        <div
          v-for="(item, index) in nodeConfig.conditionNodes"
          :key="index"
          class="col-box"
        >
          <div class="condition-node">
            <div class="condition-node-box">
              <div
                v-if="isDefaultBranchNode(index)"
                class="auto-judge default-branch-node"
              >
                <div class="title-wrapper">
                  <span class="editable-title">默认条件</span>
                  <span class="priority-title"
                    >优先级{{ item.priorityLevel }}</span
                  >
                </div>
                <div class="content-wrapper">
                  <div class="content">未满足其他条件时，将进入默认流程</div>
                </div>
              </div>
              <div v-else class="auto-judge">
                <div class="title-wrapper">
                  <input
                    v-if="nodeNameInputList[index]"
                    :ref="(el) => (nodeNameConditionRef = el)"
                    v-model="item.name"
                    type="text"
                    class="editable-title-input"
                    :maxlength="16"
                    @blur="onNameInputBlur(index)"
                    @focus="focusInput"
                  />
                  <template v-else>
                    <span
                      class="editable-title"
                      @click="onNameInputClick(index)"
                    >
                      {{ item.name }}
                    </span>
                    <span class="priority-title"
                      >优先级{{ item.priorityLevel }}</span
                    >
                    <a-link class="close" @click="onConditionRemove(index)">
                      <template #icon><icon-close /></template>
                    </a-link>
                  </template>
                </div>
                <div class="content-wrapper">
                  <div
                    v-if="index !== 0"
                    class="sort-left"
                    @click="branchSwitchIdx(index, -1)"
                  >
                    <icon-left />
                  </div>
                  <div
                    class="content"
                    @click="onNodeCardClick(item.priorityLevel)"
                  >
                    <span
                      v-if="
                        (
                          getGatewayBranch(nodeConfig, index).conditionGroups ||
                          []
                        ).length === 0
                      "
                      class="placeholder"
                      >请设置条件</span
                    >
                    <a-tooltip
                      v-else
                      mini
                      :content="showConditionContent(nodeConfig, index)"
                      content-class="node-content-tooltip"
                    >
                      <span class="text">{{
                        showConditionContent(nodeConfig, index)
                      }}</span>
                    </a-tooltip>
                  </div>
                  <div
                    v-if="
                      index !== nodeConfig.conditionNodes.length - 1 &&
                      !isDefaultBranchNode(index + 1)
                    "
                    class="sort-right"
                    @click="branchSwitchIdx(index)"
                  >
                    <icon-right />
                  </div>
                </div>
              </div>
              <AddNode v-model:childNodeP="item.childNode" />
            </div>
          </div>
          <NodeWrap
            v-if="item.childNode"
            v-model:nodeConfig="item.childNode"
            @click-node-card="emitClickNodeCard"
          />
          <template v-if="index === 0">
            <div class="top-left-cover-line"></div>
            <div class="bottom-left-cover-line"></div>
          </template>
          <template v-if="index === nodeConfig.conditionNodes.length - 1">
            <div class="top-right-cover-line"></div>
            <div class="bottom-right-cover-line"></div>
          </template>
        </div>
      </div>
      <AddNode v-model:childNodeP="nodeConfig.childNode" />
    </div>
  </div>

  <!-- 分支汇合节点 -->
  <NodeWrap
    v-if="nodeConfig.childNode"
    v-model:nodeConfig="nodeConfig.childNode"
    @click-node-card="emitClickNodeCard"
  />
</template>

<script lang="ts" setup>
  import { IconClose, IconRight } from '@arco-design/web-vue/es/icon';
  import {
    computed,
    // onMounted,
    reactive,
    ref,
    toRefs,
    nextTick,
    PropType,
  } from 'vue';
  import {
    NODE,
    ASSIGNEE,
  } from '@/views/basis/auditConfig/components/flow/constants';
  import type { NODE_TYPE } from '@/views/basis/auditConfig/components/flow/constants';
  import useListDataStore from '@/store/modules/list-data';
  import useFlowStore from '@/store/modules/flow';
  import { getBranchNodeListData, isNotNullCondition } from './common';

  // 属性
  const props = defineProps({
    nodeConfig: { type: Object as PropType<Recordable>, default: () => ({}) },
    flowPermission: { type: Object, default: () => ({}) },
  });

  const { nodeConfig } = toRefs(props);

  const emits = defineEmits([
    'update:flowPermission',
    'update:nodeConfig',
    'clickNodeCard',
  ]);
  const flowStore = useFlowStore();
  const listDataStore = useListDataStore();

  const nodeNameRef = ref();
  const nodeNameConditionRef = ref();

  // 节点基本信息
  const nodeSettings = reactive<Recordable>({
    [NODE.START]: { placeholder: '发起人', bgColor: '#87dd8c' },
    [NODE.APPROVE]: { placeholder: '审批人', bgColor: '#ff943e' },
    [NODE.COPY]: { placeholder: '抄送人', bgColor: '#3296fa' },
  });
  const nodeDefaultName = computed(
    () => nodeSettings[nodeConfig.value.type as NODE_TYPE].placeholder
  );
  const nodeBgColor = computed(
    () => nodeSettings[nodeConfig.value.type as NODE_TYPE].bgColor
  );

  // nodeType 0发起人 1审批 2抄送 3条件 4路由
  // 节点卡片显示的内容
  const showNodeContent = computed(() => {
    const nodeType = nodeConfig.value.type;
    if (nodeType === NODE.START) {
      // 开始节点
      return '提交';
    }
    if ([NODE.APPROVE, NODE.COPY].includes(nodeType)) {
      // 审批人节点 抄送人节点
      const { assignees } = nodeConfig.value;
      return (
        assignees
          ?.map((cc: Recordable) => {
            const { assigneeType, assignees: assignees0 } = cc;
            if (assigneeType === ASSIGNEE.SELF) return '发起人本人';
            if (assigneeType === ASSIGNEE.ROLE) {
              return assignees0
                ?.map((item: Recordable) => item.name)
                ?.join(', ');
            }
            if (assigneeType === ASSIGNEE.ASSIGNEE) {
              return assignees0
                ?.map((item: Recordable) => item.name)
                ?.join(', ');
            }
            return '';
          })
          ?.filter(Boolean)
          ?.join(', ') ?? ''
      );
    }
    return null;
  });

  const isNodeNameEdit = ref(false);

  // 是否为默认分支节点
  const isDefaultBranchNode = (idx: number) => {
    return props.nodeConfig.conditionNodes.length === idx + 1;
  };
  const getGatewayBranch = (gateway: Recordable, index: number) => {
    return gateway.conditionNodes[index];
  };

  // 条件节点卡片上的展示文字
  const showExpNodeContent = (branchNode: Recordable) => {
    // 审批流程支持的条件字段
    const { conditionFields = [] } = flowStore;
    const { getListDataOptionByFieldAndIds } = listDataStore;
    const { conditionGroups } = branchNode;
    return `当 ${conditionGroups
      .map((conditionGroup: Recordable) => {
        const { conditions } = conditionGroup;
        return conditions
          .filter((e: Recordable) => isNotNullCondition(e))
          .map((condition: Recordable) => {
            let name;
            let operatorName;
            let newVal;
            const { field, conditionType, values } = condition;
            const conditionField = conditionFields.find(
              (item: Recordable) => item.field === field
            );
            if (conditionField) {
              const { supportConditionTypes, valueSelectType } = conditionField;
              name = conditionField.fieldDisplay ?? '';
              operatorName =
                // 支持的操作符列表
                supportConditionTypes.find(
                  (item: Recordable) => item.conditionType === conditionType
                )?.display ?? '';
              const options: Recordable = {
                field: valueSelectType,
                idList: values,
              };
              if (valueSelectType === 'YEAR') {
                options.formatter = (val: any) => {
                  const year = Math.floor(Number(val));
                  const half = Number(val) % 1;
                  return `${year}${half === 0.5 ? '下半' : '上半'}年`;
                };
              }
              const dataOption = getListDataOptionByFieldAndIds(options);
              newVal = dataOption.labels.join(dataOption.conditionJoinSymbol);
            }
            if (conditionType.includes('_BETWEEN')) {
              return `${name ?? ''} 介于 ${newVal ?? ''} 之间`;
            }
            return `${name ?? ''} ${operatorName ?? ''} ${newVal ?? ''}`;
          })
          .join(' 且 ');
      })
      .join(' 或 ')}`;
  };
  // 分支卡片显示的内容
  const showConditionContent = (nodeCfg: Recordable, index: number) => {
    const branchNode = nodeCfg.conditionNodes[index];
    return showExpNodeContent(branchNode) ?? '';
  };
  const nodeNameInputList = ref<boolean[]>([]);
  // 节点名称点击事件
  const onNameInputClick = (index?: number) => {
    if (index || index === 0) {
      nodeNameInputList.value[index] = true;
      nextTick(() => {
        nodeNameConditionRef.value?.focus();
      });
    } else {
      isNodeNameEdit.value = true;
      nextTick(() => {
        nodeNameRef.value?.focus();
      });
    }
  };

  // 节点名称离开事件
  const onNameInputBlur = (index?: number) => {
    if (index || index === 0) {
      nodeNameInputList.value[index] = false;
      nodeConfig.value.conditionNodes[index].name =
        nodeConfig.value.conditionNodes[index].name || '条件';
    } else {
      isNodeNameEdit.value = false;
      nodeConfig.value.name = nodeConfig.value.name || nodeDefaultName.value;
    }
  };
  const focusInput = (e: any) => {
    e?.currentTarget?.select();
  };

  // 删除节点
  const onNodeRemove = () => {
    emits('update:nodeConfig', nodeConfig.value.childNode);
  };

  // 新增分支条件
  const onConditionAdd = () => {
    const len = nodeConfig.value.conditionNodes.length + 1;
    nodeConfig.value.conditionNodes.push({
      name: `条件${len}`,
      type: NODE.CONDITION,
      priorityLevel: len,
      conditionGroups: [],
      childNode: null,
    });
    emits('update:nodeConfig', nodeConfig.value);
  };

  // 删除分支条件
  const onConditionRemove = (index: number) => {
    nodeConfig.value.conditionNodes.splice(index, 1);
    nodeConfig.value.conditionNodes.forEach((item: Recordable, i: number) => {
      item.priorityLevel = i + 1;
      item.name = `条件${i + 1}`;
    });
    emits('update:nodeConfig', nodeConfig.value);
    if (nodeConfig.value.conditionNodes.length === 1) {
      if (nodeConfig.value.childNode) {
        if (nodeConfig.value.conditionNodes[0].childNode) {
          reconnectNode(
            nodeConfig.value.conditionNodes[0].childNode,
            nodeConfig.value.childNode
          );
        } else {
          nodeConfig.value.conditionNodes[0].childNode =
            nodeConfig.value.childNode;
        }
      }
      emits('update:nodeConfig', nodeConfig.value.conditionNodes[0].childNode);
    }
  };

  // 删除分支后重新连接节点
  const reconnectNode = (data: Recordable, addData: Recordable) => {
    if (!data.childNode) {
      data.childNode = addData;
    } else {
      reconnectNode(data.childNode, addData);
    }
  };

  // type 0 发起人 1审批 2抄送 3条件 4路由
  // 如果是非分支节点，则不需要传递参数
  // 节点卡片点击
  const onNodeCardClick = (priorityLevel?: number) => {
    const { type } = nodeConfig.value;
    if ([NODE.APPROVE, NODE.COPY].includes(type)) {
      // 审批人 抄送人
      emitClickNodeCard({
        type,
        value: JSON.parse(JSON.stringify(nodeConfig.value)),
        updateCallback: (data: Recordable) => {
          emits('update:nodeConfig', data);
        },
      });
    }
    if ([NODE.EXCLUSIVE_GATEWANY].includes(type)) {
      // 审批人 抄送人
      emitClickNodeCard({
        type,
        priorityLevel,
        value: JSON.parse(JSON.stringify(nodeConfig.value)),
        updateCallback: async (data: Recordable) => {
          await getBranchNodeListData(data.conditionNodes);
          emits('update:nodeConfig', data);
        },
      });
    }
  };

  const emitClickNodeCard = (data: Recordable) => {
    emits('clickNodeCard', data);
  };

  // 分支条件交换位置
  const branchSwitchIdx = (index: number, type = 1) => {
    // 向左-1,向右1
    // eslint-disable-next-line prefer-destructuring
    nodeConfig.value.conditionNodes[index] =
      nodeConfig.value.conditionNodes.splice(
        index + type,
        1,
        nodeConfig.value.conditionNodes[index]
      )[0];

    nodeConfig.value.conditionNodes.forEach((item: Recordable, i: number) => {
      item.priorityLevel = i + 1;
    });
    emits('update:nodeConfig', nodeConfig.value);
  };
</script>

<style lang="less">
  @node-padding: 12px;
  @node-width: 210px;
  @node-heigth: 78px;
  @node-border-radius: 8px;
  // @canvas-bg: #f5f5f7;
  @canvas-bg: #f2f3f5;

  .node-wrap,
  .branch-wrap {
    display: inline-flex;
    width: 100%;
    box-sizing: border-box;

    // 头部输入框
    .editable-title-input {
      width: 100%;
      height: 18px;
      margin: 0;
      padding-left: 4px;
      font-size: 12px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.65);
      background-color: #fff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      transition: all 0.3s;

      &::placeholder {
        color: #bfbfbf;
      }

      &:focus {
        outline: 0;
        border-color: #40a9ff;
        box-shadow: 0 0 0 1px rgba(24, 144, 255, 0.2);
      }

      &:hover {
        text-decoration: none;
        border-color: #40a9ff;
      }
    }
  }

  // 节点卡片、分支卡片样式
  .node-wrap .node-wrap-box,
  .branch-wrap .auto-judge {
    &::after {
      pointer-events: none;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 2;
      border-radius: @node-border-radius;
      border: 1px solid transparent;
      transition: all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
      box-shadow: 0 2px 5px #0000001a;
    }

    &:hover {
      &::after {
        // border: 1px solid #3296fa;
        // box-shadow: 0 0 6px #3296fa4d;
        box-shadow: 0 13px 27px 0 #0000001a;
      }
    }

    .close {
      display: none;

      .arco-link-icon {
        color: #8f959e;
        margin-right: 0;
      }
    }
  }

  // 节点样式
  .node-wrap {
    flex-direction: column;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    padding: 0 50px;
    position: relative;

    .start-node {
      &::before {
        content: none !important;
      }
    }

    .node-wrap-box {
      position: relative;
      width: @node-width;
      min-height: @node-heigth;
      background: #fff;
      border-radius: @node-border-radius;
      cursor: pointer;
      display: flex;
      flex-direction: column;

      &::before {
        content: '';
        position: absolute;
        top: -8px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translate(-50%);
        width: 0;
        height: 4px;
        border-style: solid;
        border-width: 8px 6px 4px;
        border-color: #cacaca transparent transparent;
        background: @canvas-bg;
      }

      &:hover {
        .close {
          display: inherit;
        }
      }

      .title {
        z-index: 9;
        border-radius: @node-border-radius @node-border-radius 0 0;
        min-height: 28px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #fff;
        padding: 0 @node-padding;

        &:hover {
          .editable-title span {
            border-bottom: 1px dashed #fff;
          }
        }

        .iconfont {
          font-size: 12px;
          margin-right: 5px;
        }

        .editable-title {
          flex: 1;
        }
      }

      .content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px @node-padding;

        .text {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-wrap: break-word;
          word-break: break-all;
          display: -webkit-box;
          line-clamp: 2;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .placeholder {
          color: #a1a5ad;
        }
      }
    }
  }

  // 分支
  .branch-wrap {
    .branch-box-wrap {
      display: flex;
      -webkit-box-orient: vertical;
      flex-direction: column;
      flex-wrap: wrap;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      min-height: 270px;
      width: 100%;
      -ms-flex-negative: 0;
      flex-shrink: 0;

      .branch-box {
        display: flex;
        overflow: visible;
        min-height: 180px;
        height: auto;
        border-bottom: 2px solid #ccc;
        border-top: 2px solid #ccc;
        position: relative;
        margin-top: 15px;

        .col-box {
          background: @canvas-bg;
          display: inline-flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          flex-direction: column;
          -webkit-box-align: center;
          align-items: center;
          position: relative;

          &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 0;
            margin: auto;
            width: 2px;
            height: 100%;
            background-color: #cacaca;
          }

          .condition-node,
          .condition-node-box {
            display: inline-flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            flex-direction: column;
            -webkit-box-flex: 1;
          }

          .condition-node {
            /* min-height: 220px */

            .condition-node-box {
              padding-top: 30px;
              padding-right: 50px;
              padding-left: 50px;
              -webkit-box-pack: center;
              justify-content: center;
              -webkit-box-align: center;
              align-items: center;
              flex-grow: 1;
              position: relative;

              &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 2px;
                height: 100%;
                background-color: #cacaca;
              }
            }
          }
        }

        // 分页卡片样式
        .auto-judge {
          position: relative;
          width: @node-width;
          min-height: @node-heigth;
          background: #fff;
          border-radius: @node-border-radius;
          cursor: pointer;
          display: flex;
          flex-direction: column;

          &:hover {
            .priority-title {
              display: none;
            }

            .close {
              display: inherit;
            }
          }

          .title-wrapper {
            position: relative;
            font-size: 12px;
            color: #2eb795;
            min-height: 28px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 @node-padding;
            border-radius: @node-border-radius @node-border-radius 0 0;
            border-bottom: 1px solid #f6f6f7;

            &:hover {
              .editable-title {
                border-bottom: 1px dashed #2eb795;
              }
            }
          }

          .content-wrapper {
            display: flex;
            flex: 1;
            align-items: center;

            .sort-left,
            .sort-right {
              height: 100%;
              display: flex;
              align-items: center;
              padding: 0 2px;

              &:hover {
                background: #efefef;
              }
            }

            .content {
              flex: 1;
              padding: 0 @node-padding;
              min-height: 100%;
              display: flex;
              align-items: center;

              .text {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                word-wrap: break-word;
                word-break: break-all;
                display: -webkit-box;
                line-clamp: 2;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .placeholder {
                color: #a1a5ad;
              }
            }
          }
        }

        .default-branch-node {
          color: #646a73 !important;

          .title-wrapper {
            color: #646a73 !important;
          }
        }

        .add-branch {
          border: none;
          outline: none;
          user-select: none;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          padding: 0 10px;
          height: 30px;
          border-radius: 15px;
          color: #3296fa;
          background: #fff;
          cursor: pointer;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          position: absolute;
          top: -16px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1;
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

          &::after {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 15px;
          }

          &:hover {
            transform: translate(-50%);
            box-shadow: 0 13px 27px 0 #0000001a;

            // &::after {
            //   border: 1px solid #3296fa;
            //   box-shadow: 0 0 6px #3296fa4d;
            // }
          }
        }

        .top-left-cover-line {
          left: -1px;
        }

        .top-right-cover-line {
          right: -1px;
        }

        .bottom-left-cover-line {
          left: -1px;
        }

        .bottom-right-cover-line {
          right: -1px;
        }

        .top-left-cover-line,
        .top-right-cover-line {
          position: absolute;
          height: 8px;
          width: 50%;
          background-color: @canvas-bg;
          top: -4px;
        }

        .bottom-left-cover-line,
        .bottom-right-cover-line {
          position: absolute;
          height: 8px;
          width: 50%;
          background-color: @canvas-bg;
          bottom: -4px;
        }
      }
    }
  }

  .node-content-tooltip {
    font-size: 12px;
    border-radius: var(--border-radius-medium);
  }
</style>
